import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXlsx = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_6841_7458",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 32,
		height: 32,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "white"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			stroke: "currentColor"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_6841_7458)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M27.7424 2.03055C26.6252 2.02947 25.554 1.58665 24.764 0.799304C23.974 0.011961 23.5297 -1.0556 23.5286 -2.16907V-8H4.69941C3.24093 -8 1.84218 -7.42256 0.810884 -6.39474C-0.220412 -5.36692 -0.799805 -3.97293 -0.799805 -2.51937V30.5193C-0.799805 31.9729 -0.220412 33.3669 0.810884 34.3947C1.84218 35.4226 3.24093 36 4.69941 36H27.301C28.7595 36 30.1582 35.4226 31.1895 34.3947C32.2208 33.3669 32.8002 31.9729 32.8002 30.5193V2.03055H27.7424Z",
				fill: "#E3F5E3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.3015 12.9479H8.69531C7.43032 12.9479 6.40039 11.6889 6.40039 10.139V-0.457013C6.40039 -2.00488 7.43032 -3.26392 8.69531 -3.26392H23.3075C24.5705 -3.26392 25.6004 -2.00488 25.6004 -0.457013V10.139C25.5944 11.6889 24.5645 12.9479 23.3015 12.9479ZM8.69531 -1.82961C8.07576 -1.82961 7.57377 -1.21402 7.57377 -0.457013V10.139C7.57377 10.896 8.07576 11.5116 8.69531 11.5116H23.3075C23.925 11.5116 24.427 10.896 24.427 10.139V-0.457013C24.427 -1.21402 23.925 -1.82961 23.3075 -1.82961H8.69531Z",
				fill: "#9CD99E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.009 6.56714H6.98242V8.00345H25.009V6.56714Z",
				fill: "#9CD99E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.009 1.64258H6.98242V3.07889H25.009V1.64258Z",
				fill: "#9CD99E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.3914 -2.54688H18.9551V12.2286H20.3914V-2.54688Z",
				fill: "#9CD99E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.034 -2.54688H11.5977V12.2286H13.034V-2.54688Z",
				fill: "#9CD99E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.72568 20.0813V21.3608H6.40039V20.0813H7.72568Z",
				fill: "#275429"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6029 21.3606L10.4888 19.7133L9.52964 21.3606H8.06355L9.75489 18.6362L8.01074 16.0684H9.52964L10.6155 17.6629L11.5519 16.0684H13.0109L11.3424 18.733L13.1235 21.3606H11.6029Z",
				fill: "#275429"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.2757 21.3606L23.1617 19.7133L22.2025 21.3606H20.7364L22.4277 18.6362L20.6836 16.0684H22.2025L23.2884 17.6629L24.2247 16.0684H25.6837L24.0153 18.733L25.7964 21.3606H24.2757Z",
				fill: "#275429"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.3745 20.6427C20.2227 20.8857 20.0047 21.0804 19.7462 21.2041C19.4315 21.3515 19.0868 21.4232 18.7395 21.4135C18.2155 21.4355 17.6992 21.2825 17.2717 20.9788C17.0826 20.8369 16.9279 20.6542 16.8191 20.4442C16.7103 20.2343 16.6502 20.0025 16.6433 19.7662H18.0056C18.0153 19.9445 18.0912 20.1127 18.2185 20.2379C18.3452 20.356 18.5135 20.4193 18.6867 20.4139C18.7572 20.418 18.8279 20.4082 18.8947 20.3849C18.9614 20.3616 19.023 20.3254 19.0757 20.2783C19.1226 20.2328 19.1595 20.178 19.1841 20.1174C19.2086 20.0568 19.2202 19.9917 19.2182 19.9263C19.22 19.8643 19.2092 19.8026 19.1865 19.7448C19.1638 19.687 19.1297 19.6345 19.0862 19.5902C18.993 19.4959 18.8825 19.4206 18.7606 19.3684C18.6327 19.3121 18.4532 19.2434 18.2221 19.1625C17.9416 19.07 17.6676 18.9589 17.4019 18.8299C17.1836 18.7174 16.9962 18.553 16.8563 18.3511C16.6939 18.1068 16.6138 17.817 16.6275 17.524C16.6211 17.2336 16.7048 16.9483 16.8669 16.7073C17.0334 16.4718 17.2635 16.2887 17.5304 16.1793C17.838 16.0542 18.1682 15.9943 18.5002 16.0033C19.0041 15.9755 19.502 16.1243 19.9081 16.424C20.081 16.5646 20.2226 16.7397 20.3238 16.9383C20.4251 17.1368 20.4837 17.3542 20.496 17.5767H19.1109C19.0954 17.421 19.0285 17.2749 18.9208 17.1614C18.8657 17.1086 18.8005 17.0677 18.7291 17.0411C18.6577 17.0144 18.5816 17.0027 18.5054 17.0065C18.3734 17.0005 18.2438 17.0431 18.1411 17.1262C18.0937 17.1711 18.0568 17.226 18.0331 17.2868C18.0093 17.3477 17.9994 17.413 18.0038 17.4782C18.0011 17.5965 18.0454 17.711 18.127 17.7967C18.2146 17.8882 18.32 17.9607 18.4368 18.0097C18.5617 18.0643 18.7413 18.1347 18.9753 18.2191C19.2609 18.3122 19.5392 18.4263 19.8078 18.5606C20.0272 18.679 20.2164 18.8464 20.3604 19.0499C20.5247 19.2981 20.606 19.592 20.5928 19.8894C20.5904 20.1557 20.5149 20.4163 20.3745 20.6427Z",
				fill: "#275429"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6313 20.3855H16.3455V21.3658H13.3535V16.0735H14.6348L14.6313 20.3855Z",
				fill: "#275429"
			})
		]
	})]
});
export default SvgXlsx;
